@let isOpen = opened();
<!-- Host for the query container: full width like the body, so the breakpoint follows the viewport
     and not the sidebar's own width. Carries no layout of its own — both children are `fixed`. -->
<div #sidebarHostRef class="gs-responsive-container">
  <button
    tabindex="-1"
    aria-hidden="true"
    class="left-0 top-0 z-50 h-screen w-screen bg-black/40"
    (click)="enableBackdrop() ? dismiss() : null"
    [ngClass]="{
      hidden: !isOpen,
      fixed: isOpen
    }"
  ></button>
  @let bgColor = backgroundColor();
  @let pxWidth = sidebarWidth();
  @let enableTransition = hasBeenOpened();
  <!-- Closed, the panel is only translated off-screen; `inert` keeps it out of the tab order and accessibility tree -->
  <div
    [attr.inert]="isOpen ? null : ''"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="ariaLabel()"
    [gsFocusTrap]="isOpen"
    (keydown.escape)="dismiss()"
    style="z-index: 100"
    [class]="
      'fixed right-0 top-0 flex h-full max-w-full flex-col px-5 py-4 md:px-10 ' +
      (enableTransition ? 'transition-transform duration-200' : '') +
      styleService.getColorClass(bgColor, 'bg')
    "
    [style.width.px]="pxWidth"
    [style.backgroundColor]="styleService.getColorStyle(bgColor)"
    [ngClass]="{
      'bg-light-main': !bgColor,
      'shadow-dark-shine translate-x-0 shadow-2xl': isOpen,
      'translate-x-full': !isOpen
    }"
  >
    <ng-content></ng-content>
  </div>
</div>
